import { useState } from "react";
import {
  ProductDataRemovableProductCodeLiterals,
  ProductDataRemovalTask,
} from "../../../../../../application/domain/product-data-removal-task";

type ModalType = "create" | "approve" | "cancel";

type ModalState = {
  type: ModalType;
  productCode: ProductDataRemovableProductCodeLiterals;
  task?: ProductDataRemovalTask;
};

export const useProductDataRemovalTaskModals = () => {
  const [modalState, setModalState] = useState<ModalState | undefined>(
    undefined,
  );

  const handleOpenModal = (
    type: ModalType,
    productCode: ProductDataRemovableProductCodeLiterals,
    task?: ProductDataRemovalTask,
  ) => {
    setModalState({ type, productCode, task });
  };

  const handleCloseModal = () => {
    setModalState(undefined);
  };

  return {
    modalState,
    handleOpenModal,
    handleCloseModal,
  };
};
